export default "__VITE_ASSET__700a4283__"